import { Lightbulb } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import PostIdeasSection from "./PostIdeasSection";

import type { PendingTopicData } from "../components/autopilot/TopicCard";

export default function IdeasPage({
  linkedIdea,
  onCloseLinkedIdea,
}: {
  linkedIdea?: PendingTopicData;
  onCloseLinkedIdea?: () => void;
}) {
  const { activeWorkspaceId } = useAuth();
  const navigate = useNavigate();
  return (
    <div
      className="relative mx-auto max-w-6xl px-4 py-8 sm:px-8 sm:py-12"
      key={activeWorkspaceId}
    >
      <header className="mb-6">
        <div className="flex items-center gap-3">
          <Lightbulb
            className="h-6 w-6 shrink-0 text-muted-foreground"
            aria-hidden="true"
          />
          <h1 className="text-3xl font-semibold tracking-tight">
            Ideas for your next post
          </h1>
        </div>
        <p className="mt-2 pl-9 text-sm text-muted-foreground">
          Inspired by your business.
        </p>
      </header>
      <PostIdeasSection
        linkedIdea={linkedIdea}
        onCloseLinkedIdea={onCloseLinkedIdea}
        page
        onOpenDrafts={() => navigate("/created")}
      />
    </div>
  );
}
